import { supabase } from "../lib/supabase";

const API_BASE = (
  process.env.REACT_APP_AI_API_URL ||
  process.env.REACT_APP_AI_API_BASE_URL ||
  "https://colobongo.onrender.com"
).replace(/\/$/, "");

async function getAccessToken() {
  try {
    const { data } = await supabase.auth.getSession();
    return data?.session?.access_token || null;
  } catch (_error) {
    return null;
  }
}

async function authHeaders() {
  const token = await getAccessToken();
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export async function fetchInbox() {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/api/private-messages/inbox`, {
    method: "GET",
    headers,
  });
  if (!response.ok) {
    if (response.status === 401) return { messages: [], unauthorized: true };
    throw new Error(`inbox_fetch_failed_${response.status}`);
  }
  const data = await response.json();
  return { messages: Array.isArray(data?.messages) ? data.messages : [] };
}

export async function markMessageRead(messageId) {
  if (!messageId) return { success: false };
  const headers = await authHeaders();
  const response = await fetch(
    `${API_BASE}/api/private-messages/${encodeURIComponent(messageId)}/read`,
    { method: "PATCH", headers }
  );
  if (!response.ok) {
    return { success: false };
  }
  return { success: true };
}

export async function checkSent(coloriageId) {
  if (!coloriageId) {
    return { already_sent: false, button_visible: false, reason: "no_coloriage" };
  }
  const headers = await authHeaders();
  const response = await fetch(
    `${API_BASE}/api/private-messages/check-sent/${encodeURIComponent(coloriageId)}`,
    { method: "GET", headers }
  );
  if (!response.ok) {
    if (response.status === 401) {
      return { already_sent: false, button_visible: true, unauthorized: true };
    }
    return { already_sent: false, button_visible: true, reason: "fetch_failed" };
  }
  return await response.json();
}

export async function sendPrivateMessage({
  coloriageId,
  content,
  messageType = "wall_word",
  targetArtworkId = null,
}) {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/api/private-messages`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      coloriage_id: coloriageId,
      content,
      message_type: messageType,
      target_artwork_id: targetArtworkId || null,
    }),
  });
  if (response.status === 401) {
    return { success: false, error: "unauthorized" };
  }
  if (response.status === 409) {
    return { success: false, error: "already_sent" };
  }
  if (response.status === 422) {
    const data = await response.json().catch(() => ({}));
    return { success: false, error: data?.detail || "validation_error" };
  }
  if (!response.ok) {
    return { success: false, error: "server_error" };
  }
  return await response.json();
}

export async function setArtistName(artistName) {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/api/profile/artist-name`, {
    method: "POST",
    headers,
    body: JSON.stringify({ artist_name: artistName }),
  });
  if (response.status === 401) {
    return { success: false, error: "unauthorized" };
  }
  if (!response.ok) {
    return { success: false, error: "server_error" };
  }
  return await response.json();
}

export const UNREAD_EVENT = "colobongo:inbox-updated";

export function emitInboxUpdated() {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent(UNREAD_EVENT));
  } catch (_err) {
    // best-effort
  }
}
